var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"module-navigation":_vm.navigation,"module-name":"E-commerce"}}),_vm._v(" "),_c('main',{staticClass:"with-tabs",attrs:{"id":"page-main"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c3bb6ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shop/Index.vue
// module id = 700
// module chunks = 0